import { Bird } from 'lucide-react';
import { EagleAppearanceFields } from './EagleAppearanceFields';
import { HomeEagleAnimation } from './HomeEagleAnimation';
import { useEaglePreferences } from './useEaglePreferences';

export const HomeAnimationSetting = ({ userId }) => {
  const { preferences, update, saveError } = useEaglePreferences(userId);
  return <section className="home-eagle-settings-section px-4 py-4 border-b border-[var(--ps-border)] space-y-4"
    aria-labelledby="home-animation-setting-title" data-testid="home-animation-setting">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h2 id="home-animation-setting-title" data-testid="home-animation-setting-title" className="flex items-center gap-2 text-sm font-medium">
        <Bird size={16} className="text-[var(--ps-primary)]" aria-hidden="true" />Home animation
      </h2>
      <span className="text-xs text-[var(--ps-text-muted)]" data-testid="home-animation-storage-scope">This device</span>
    </div>
    <HomeEagleAnimation userId={userId} idPrefix="settings-eagle-preview" showAppearance={false} />
    <EagleAppearanceFields preferences={preferences} onChange={update} saveError={saveError} idPrefix="settings-home-eagle" />
  </section>;
};